import { render } from "./entity_review_quote.html?vue&type=template&id=701e1f88&external"
import script from "./entity_review_quote.js?vue&type=script&lang=js&external"
export * from "./entity_review_quote.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__